import Phaser from 'phaser'
import Cone from '../actors/cone'
import Oilslick from '../actors/oilslick'
import { LAYER_GRASS, LAYER_ROAD } from '../layers'

export const GUARDRAIL_DISTANCE = 150

class RoadSection {
  constructor (scene, previous, index) {
    this.scene = scene
    this.previous = previous
    this.index = index

    this.y = !previous ? 0 : previous.y - previous.height
    const growth = !scene.player.hasMoved ? 0 : scene.rnd.integerInRange(-1, 1)
    this.laneCount = index === 0 || !previous ? 3 : Phaser.Math.Clamp(previous.laneCount + growth, 3, 6)

    if (index === 0 || !previous) {
      this.laneOffset = -1
    } else if (this.laneCount === previous.laneCount) {
      this.laneOffset = previous.laneOffset
    } else {
      let offset = scene.rnd.integerInRange(0, 1)
      if (this.laneCount > previous.laneCount) {
        offset *= -1
      }
      this.laneOffset = Phaser.Math.Clamp(previous.laneOffset + offset, -2, -1)
    }
    this.laneWidth = 90
    this.height = this.laneWidth * 20

    this.objects = []
    if (!this.previous) {
      this.previous = this
    }
  }

  add (obj, addToScene = false) {
    if (addToScene) {
      this.scene.add.existing(obj)
      this.scene.objects.add(obj)
    } else {
      this._road.add(obj)
    }
    this.objects.push(obj)
  }

  populate (road, next) {
    this._road = road
    const screenWidth = this.scene.scale.width

    const grass = this.scene.add.tileSprite(-200, this.y, screenWidth + 800, this.height, 'environ', 'land_grass04')
    grass.setDepth(LAYER_GRASS)
    this.add(grass)

    const previous = this.previous
    const growRight = this.laneCount > previous.laneCount && this.laneOffset === previous.laneOffset
    const growLeft = this.laneCount > previous.laneCount && this.laneOffset < previous.laneOffset
    const shrinkRight = next.laneCount < this.laneCount && next.laneOffset === this.laneOffset
    const shrinkLeft = next.laneCount < this.laneCount && next.laneOffset > this.laneOffset

    const lanes = this.getLanes()
    lanes.forEach((x, i) => {
      let y = this.y
      const frame = i === 0 ? 'road_left' : i === this.laneCount - 1 ? 'road_right' : 'road_middle'

      let height = this.height
      if (growRight && i === this.laneCount - 1) {
        height -= this.laneWidth
        const y = this.y + this.height - this.laneWidth / 2
        const frame = 'road_wider_right'
        const part = this.scene.add.image(x, y, 'environ', frame)
        part.setDisplaySize(this.laneWidth, this.laneWidth)
        part.setDepth(LAYER_ROAD)
        this.add(part)
      }
      if (growLeft && i === 0) {
        height -= this.laneWidth
        const y = this.y + this.height - this.laneWidth / 2
        const frame = 'road_wider_left'
        const part = this.scene.add.image(x, y, 'environ', frame)
        part.setDisplaySize(this.laneWidth, this.laneWidth)
        part.setDepth(LAYER_ROAD)
        this.add(part)
      }
      if (shrinkRight && i === this.laneCount - 1) {
        height -= this.laneWidth
        y += this.laneWidth
        const party = this.y + this.laneWidth / 2
        const frame = 'road_smaller_right'
        const part = this.scene.add.image(x, party, 'environ', frame)
        part.setDisplaySize(this.laneWidth, this.laneWidth)
        part.setDepth(LAYER_ROAD)
        this.add(part)
      }
      if (shrinkLeft && i === 0) {
        height -= this.laneWidth
        y += this.laneWidth
        const party = this.y + this.laneWidth / 2
        const frame = 'road_smaller_left'
        const part = this.scene.add.image(x, party, 'environ', frame)
        part.setDisplaySize(this.laneWidth, this.laneWidth)
        part.setDepth(LAYER_ROAD)
        this.add(part)
      }

      const part = this.scene.add.tileSprite(x, y, this.laneWidth, height, 'environ', frame)
      part.setOrigin(0.5, 0)
      part.setTileScale(90 / 128)
      part.setDepth(LAYER_ROAD)
      this.add(part)
    })

    const rightRail = this.scene.add.tileSprite(lanes[lanes.length - 1] + GUARDRAIL_DISTANCE, this.y, this.laneWidth, this.height, 'environ', 'guardrail_right')
    rightRail.setOrigin(0.5, 0)
    rightRail.setTileScale(90 / 128)
    rightRail.setDepth(LAYER_ROAD)
    this.add(rightRail)

    const leftRail = this.scene.add.tileSprite(lanes[0] - GUARDRAIL_DISTANCE, this.y, this.laneWidth, this.height, 'environ', 'guardrail_left')
    leftRail.setOrigin(0.5, 0)
    leftRail.setTileScale(90 / 128)
    leftRail.setDepth(LAYER_ROAD)
    this.add(leftRail)

    if (shrinkLeft) {
      leftRail.y += this.laneWidth
      leftRail.height -= this.laneWidth
      const rail = this.scene.add.image(lanes[0] - GUARDRAIL_DISTANCE + 45, this.y, 'environ', 'guardrail_left_smaller')
      rail.setDisplaySize(this.laneWidth * 2, this.laneWidth)
      rail.setOrigin(0.5, 0)
      rail.setDepth(LAYER_ROAD)
      this.add(rail)
    }
    if (shrinkRight) {
      rightRail.y += this.laneWidth
      rightRail.height -= this.laneWidth
      const rail = this.scene.add.image(lanes[lanes.length - 1] + GUARDRAIL_DISTANCE - 45, this.y, 'environ', 'guardrail_right_smaller')
      rail.setDisplaySize(this.laneWidth * 2, this.laneWidth)
      rail.setOrigin(0.5, 0)
      rail.setDepth(LAYER_ROAD)
      this.add(rail)
    }
    if (growLeft) {
      leftRail.height -= this.laneWidth
      const rail = this.scene.add.image(lanes[0] - GUARDRAIL_DISTANCE + 45, this.y + this.height - this.laneWidth, 'environ', 'guardrail_left_wider')
      rail.setDisplaySize(this.laneWidth * 2, this.laneWidth)
      rail.setOrigin(0.5, 0)
      rail.setDepth(LAYER_ROAD)
      this.add(rail)
    }
    if (growRight) {
      rightRail.height -= this.laneWidth
      const rail = this.scene.add.image(lanes[lanes.length - 1] + GUARDRAIL_DISTANCE - 45, this.y + this.height - this.laneWidth, 'environ', 'guardrail_right_wider')
      rail.setDisplaySize(this.laneWidth * 2, this.laneWidth)
      rail.setOrigin(0.5, 0)
      rail.setDepth(LAYER_ROAD)
      this.add(rail)
    }

    this.spawnOilslicks(road)
    this.spawnCones(road)
  }

  spawnCones (road) {
    const rnd = this.scene.rnd
    const lanes = this.getLanes()
    const left = lanes[0]
    const right = lanes[lanes.length - 1]
    const count = rnd.pick([0, 1, 1, 2])
    for (let i = 0; i < count; i++) {
      const cone = new Cone(road.scene, rnd.realInRange(left, right), this.y + rnd.realInRange(30, this.height - 30))
      this.add(cone, true)
      cone.initialize()
    }
    if (rnd.frac() < 0.3) {
      const x = rnd.frac() < 0.9 ? left - 27 : right + 60
      const y = this.y + rnd.realInRange(100, 140)

      const count = rnd.integerInRange(4, 8)
      for (let i = 0; i < count; i++) {
        const cone = new Cone(road.scene, x, y + i * 70)
        this.add(cone, true)
        cone.initialize()
      }
    }
  }

  spawnOilslicks (road) {
    if (this.scene.player.score < 50) {
      return
    }

    const rnd = this.scene.rnd
    const lanes = this.getLanes()
    const left = lanes[0]
    const right = lanes[lanes.length - 1]
    const count = rnd.pick([0, 0, 0, 0, 1, 1, 2])
    for (let i = 0; i < count; i++) {
      const oil = new Oilslick(road.scene, rnd.realInRange(left, right), this.y + rnd.realInRange(30, this.height - 30))
      this.add(oil, true)
      oil.initialize()
    }
  }

  getLanes () {
    return [...Array(this.laneCount).keys()].map(i => this.laneWidth * (i + this.laneOffset))
  }
}

export default class Road extends Phaser.GameObjects.Container {
  /**
   * @param {Phaser.Scene} scene
   * @param {Player} player
   */
  constructor (scene, player) {
    super(scene)
    this.player = player

    this.sections = []
    this.setDepth(LAYER_ROAD)

    this.appendSection()
  }

  appendSection () {
    const previous = this.sections.length > 0 ? this.sections[this.sections.length - 1] : undefined
    const current = new RoadSection(this.scene, previous, previous ? previous.index + 1 : 0)
    this.sections.push(current)
    if (previous) {
      previous.populate(this, current)
    }
  }

  update (time, delta) {
    const newest = this.sections[this.sections.length - 1]
    if (newest.y > this.player.y - 5000) {
      this.appendSection()
    }

    const current = this.getSectionAt(this.player.y)
    current.active = true
    const lanes = this.getLanesAt(this.player.y)
    const halfLane = current.laneWidth / 2
    this.player.lane = -1
    lanes.forEach((l, i) => {
      if (this.player.x > l - halfLane && this.player.x < l + halfLane) {
        this.player.lane = i
      }
    })
    if (this.player.lane < 0) {
      this.scene.cameras.main.shake(100, 0.003)
    }

    const oldest = this.sections[0]
    if (oldest.y > this.player.y + this.scene.scale.height * 2) {
      this.sections.shift()
      oldest.objects.forEach(o => o.destroy())
    }
  }

  getSectionAt (y) {
    let section = null
    this.sections.some(s => {
      if (y > s.y) {
        section = s
        return true
      }
    })
    return section
  }

  getLanesAt (y) {
    const section = this.getSectionAt(y)
    if (!section) {
      return []
    }
    return section.getLanes()
  }
}
